import { FC } from 'react'

import Icon from '@/components/Icon'
import { IconNameType } from '@/components/Icon/types/type'
import { cn } from '@/utils'

interface IEmptyStateProps {
  text: string
  className?: string
  textClassName?: string
  iconName?: IconNameType
  iconClassName?: string
}

const EmptyState: FC<IEmptyStateProps> = ({
  text,
  className,
  textClassName,
  iconName = 'ContentEmpty',
  iconClassName = 'mb-[30px] h-[131px] w-[254px] shrink-0',
}) => {
  return (
    <div className={cn('g-empty-state', className)}>
      <Icon name={iconName} className={iconClassName} />
      <span className={textClassName}>{text}</span>
    </div>
  )
}

export default EmptyState
